module.exports = __webpack_public_path__ + "media/images/small-sad-bus-eaac540a72cc7142ea1b9ab81c143983.png";